package org.molap.dataframe

import org.molap.index.DefaultUniqueIndex
import org.molap.index.UniqueIndex
import kotlin.reflect.KClass

class MapDataFrame<R,M,C,V>(private val map: Map<R,M>, private val columns: Map<C,Column<M,V>>) : AbstractDataFrame<R,C,Any?>() {
    override fun getColumnClass(column: C): KClass<*> {
        return columns[column]!!.type
    }

    override fun getValueAt(row: R, column: C): V {
        return columns[column]!!.values(map[row]!!)
    }

    override val rowIndex: UniqueIndex<R> = DefaultUniqueIndex(map.keys, true)

    override val columnIndex: UniqueIndex<C> = DefaultUniqueIndex(columns.keys, true)

    override fun getRowClass(row: R): KClass<*>? {
        return Any::class
    }}
